
// var carousel = $(".main_product_slider .carousel"),
//     items = $(".main_product_slider .carousel .main-product"),
//     currdeg  = 0;

//     $(".main_product_slider_wrapper .next").on("click", { d: "n" }, rotate);
//     $(".main_product_slider_wrapper .prev").on("click", { d: "p" }, rotate);

//     function rotate(e){
//     if(e.data.d=="n"){
//         currdeg = currdeg - 60;
//     }
//     if(e.data.d=="p"){
//         currdeg = currdeg + 60;
//     }
//     carousel.css({
//         "-webkit-transform": "rotateY("+currdeg+"deg)",
//         "-moz-transform": "rotateY("+currdeg+"deg)",
//         "-o-transform": "rotateY("+currdeg+"deg)",
//         "transform": "rotateY("+currdeg+"deg)"
//     });
//         items.css({
//         "-webkit-transform": "rotateY("+(-currdeg)+"deg)",
//         "-moz-transform": "rotateY("+(-currdeg)+"deg)",
//         "-o-transform": "rotateY("+(-currdeg)+"deg)",
//         "transform": "rotateY("+(-currdeg)+"deg)"
//     });
//   }

var vids = $(".video-section video"); 
  $.each(vids, function(){
     this.controls = false; 
  }); 

 // var video = $('.video-section video').get(0);
 //  $(".video-section .video-wrapper .play-icon").click(function() {
 //    if (video.paused){
 //      video.play();
 //      $(".video-section .video-wrapper .play-icon").hide(200);
 //    }
 //  });
 //  $(".video-section video").click(function() {
 //      video.pause();
 //      $(".video-section .video-wrapper .play-icon").show(200);
 //  });

var video = $('.video-section video').get(0);
  $(this).click(function() {
    if (video.paused){
      video.play();
    }
    else{
      video.pause();
    }
  });
 

$(document).ready(function(){
var rev = $('.rev_slider');
rev.on('init', function(event, slick, currentSlide) {
  var
    cur = $(slick.$slides[slick.currentSlide]),
    next = cur.next(),
    prev = cur.prev();
  prev.addClass('slick-sprev');
  next.addClass('slick-snext');
  cur.removeClass('slick-snext').removeClass('slick-sprev');
  slick.$prev = prev;
  slick.$next = next;
}).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  console.log('beforeChange');
  var
    cur = $(slick.$slides[nextSlide]);
  console.log(slick.$prev, slick.$next);
  slick.$prev.removeClass('slick-sprev');
  slick.$next.removeClass('slick-snext');
  next = cur.next(),
    prev = cur.prev();
  prev.prev();
  prev.next();
  prev.addClass('slick-sprev');
  next.addClass('slick-snext');
  slick.$prev = prev;
  slick.$next = next;
  cur.removeClass('slick-next').removeClass('slick-sprev');
});

rev.slick({
  speed: 1000,
  arrows: true,
  dots: false,
  focusOnSelect: true,
  prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0603/7645/files/image_4.svg?v=1679921218" class="prev">',
  nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0603/7645/files/image_4_-svg.svg?v=1679921218" class="next">',
  infinite: true,
  centerMode: true,
  // slidesPerRow: 1,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerPadding: '0px',
  // swipe: true,
  customPaging: function(slider, i) {
    return '';
  },
  /*infinite: false,*/
});  


$(document).on("change",".jet-blue-form .jet-agree",function() {
  console.log('chnage');
    if ($(this).is(':checked')) {
      console.log('check');
      $('.jet-blue-form .contact__button button[type="submit"]').prop('disabled',false);
    }
    else {
      console.log('not chek');
     $('.jet-blue-form .contact__button button[type="submit"]').prop('disabled',true);
    }
});  


  
})

// window.onscroll = function() {scrollFunction()};
// function scrollFunction() {
//   if (document.body.scrollTop > 400 || document.documentElement.scrollTop > 400) {
//     document.querySelector(".right-img img").style.width = "200px";document.querySelector(".right-img img").style.transform = "translateX(400px)";
//   } else {
//     document.querySelector(".right-img img").style.width = "550px";document.querySelector(".right-img img").style.transform = "translateX(0px)";
//   }
// }

// 

